import CouponError from './CouponsError';
class CouponNotFound extends CouponError {
    couponId;
    propertyId;
    constructor(couponId, propertyId, options) {
        super('Promotional coupon not found', options);
        this.couponId = couponId;
        this.propertyId = propertyId;
    }
}
export default CouponNotFound;
